module.exports = __webpack_public_path__ + "img/newsImg8.b3452cd4.png";